let today = new Date();
let arriveDate = new Date();
arriveDate.setDate(arriveDate.getDate() + 3 );

let arriveDate2 =new Date();
arriveDate2.setDate(arriveDate2.getDate() + 5 );
let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

document.querySelector(".order-date").textContent = 
today.getDate() + " " + months [ today.getMonth()] + " " +  today.getFullYear();


document.querySelector(".arrive-date").textContent = 
arriveDate.getDate() + " " + months [arriveDate.getMonth()] + "-" + 
arriveDate2.getDate() + " " + months [arriveDate2.getMonth()] + " " +  arriveDate.getFullYear();